// extracted by mini-css-extract-plugin
export default {"signupText":"styles_signupText__YD+E9","signupLink":"styles_signupLink__TY2VN"};